import { create } from "zustand";

export type TNotification =
    | {
          id: string;
          title: string;
          description: string;
          type: "info";
          value: never;
      }
    | {
          id: string;
          title: string;
          description: string;
          type: "progress";
          value: number;
      };

export type NotificationState = {
    notifications: TNotification[];
    isNotificationBellOpen: boolean;
    setNotifications: (notifications: TNotification[]) => void;
    pushNotification: (notification: TNotification) => void;
    updateNotification: (notification: TNotification) => void;
    setIsNotificationBellOpen: (open: boolean) => void;
    clearNotifications: () => void;
};

export const useNotificationStore = create<NotificationState>((set) => ({
    notifications: [],
    isNotificationBellOpen: false,
    setNotifications: (notifications) => set({ notifications }),
    pushNotification: (notification) => {
        set((state) => {
            let notifications = state.notifications;
            if (state.notifications.find((n) => n.id === notification.id)) {
                notifications = state.notifications.map((n) => (n.id === notification.id ? notification : n));
            }
            else {
                notifications = [notification, ...state.notifications];
                state.setIsNotificationBellOpen(true);
            }
            return { notifications };
        });
    },
    updateNotification: (notification) => {
        set((state) => {
            const notifications = state.notifications.map((n) => (n.id === notification.id ? notification : n));
            return { notifications };
        });
    },
    setIsNotificationBellOpen: (open: boolean) => set({ isNotificationBellOpen: open }),
    clearNotifications: () => set({ notifications: [] }),
}));
